<template>
  <div>
    <vxe-grid
      ref="goodsTable"
      auto-resize
      highlight-hover-row
      :data="tableData"
      :loading="loading"
      :columns="tableColumns"
      :height="300"
      :toolbar-config="{ slots: { buttons: 'toolbar_form' } }"
      size="mini"
      border
      resizable
      :edit-rules="validRules"
      :edit-config="{
        enabled: !disabled && packingType !== 'B',
        trigger: 'click',
        mode: 'row',
        activeMethod: activeCellMethod,
      }"
      @edit-closed="onEditClosed"
    >
      <template v-slot:toolbar_form>
        <slot name="header"> </slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            v-if="!disabled"
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>

    <el-dialog
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="qtyDialogVisible"
      width="30%"
      :modal-append-to-body="false"
      :modal="false"
    >
      <span class="spStyle"> 输入的批次数量 {{ this.param.qty }} 个</span>
      <span class="spStyle"> 会产生{{ this.param.surplusQty }}个尾箱数量</span>
      <span class="spStyle">
        已自动转换整箱批次数量 {{ this.param.newQty }}个
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="() => (qtyDialogVisible = false)"
          type="primary"
          size="mini"
        >
          {{ '确认' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import { divideDown, multiply } from '@/libs/util.number.js'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    packingType: { type: String, default: 'A' },
  },
  data() {
    return {
      qtyDialogVisible: false,
      tableColumns: tableColumns(this),
      validRules: {
        qty: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
          {
            validator: ({ cellValue, row }) => {
              if (null == cellValue || undefined == cellValue) {
                return new Error(this.$l('INDEX.tips_input_placeholder'))
              }
              if (!cellValue) {
                return new Error('产品数量不能为0')
              }
              const { inPackageQty } = row
              const boxQty = divideDown(cellValue, inPackageQty, 0)
              const newQty = multiply(boxQty, inPackageQty)
              if (newQty != cellValue) {
                return new Error(`存在${cellValue - newQty}个尾箱数量`)
              }
            },
          },
        ],
      },
      divideDown: divideDown,
      param: { qty: 0, newQty: 0, surplusQty: 0 },
    }
  },
  watch: {
    packingType: {
      handler(e) {
        if (this.disabled) return
        const $goodsTable = this.$refs.goodsTable
        if (!$goodsTable) return
        const columnBoxQty = $goodsTable.getColumnByField('boxQty')
        const columnOpt = $goodsTable.getColumnByField('col-opt')

        if (e === 'B') {
          $goodsTable.hideColumn(columnBoxQty)
          $goodsTable.hideColumn(columnOpt)
        } else {
          $goodsTable.showColumn(columnBoxQty)
          $goodsTable.showColumn(columnOpt)
        }
        $goodsTable.refreshColumn()
      },
    },
  },
  mounted() {
    if (this.disabled) return
    const $goodsTable = this.$refs.goodsTable
    if (!$goodsTable) return
    const columnBoxQty = $goodsTable.getColumnByField('boxQty')
    const columnOpt = $goodsTable.getColumnByField('col-opt')
    if (this.packingType === 'B') {
      $goodsTable.hideColumn(columnBoxQty)
      $goodsTable.hideColumn(columnOpt)
    } else {
      $goodsTable.showColumn(columnBoxQty)
      $goodsTable.showColumn(columnOpt)
    }
    $goodsTable.refreshColumn()
  },
  methods: {
    activeCellMethod({ columnIndex }) {
      if (this.packingType === 'B') {
        if (columnIndex === 5) {
          return false
        }
      }
      return true
    },
    del(row) {
      let index = this.$refs.goodsTable.getRowIndex(row)
      this.tableData.splice(index, 1)
      this.tableDataChange()
    },
    getTableData() {
      const data = this.$refs.goodsTable.getTableData()
      return data?.tableData || []
    },
    async validate() {
      return !(await this.$refs.goodsTable.validate(true))
    },
    onEditClosed({ row }) {
      const boxQty = divideDown(row.qty, row.inPackageQty, 0)
      const newQty = multiply(boxQty, row.inPackageQty)
      if (newQty != row.qty) {
        this.param.newQty = newQty
        this.param.qty = row.qty
        this.param.surplusQty = row.qty - newQty
        this.qtyDialogVisible = true
      }
      row.qty = newQty
      row.boxQty = boxQty
      this.tableDataChange()
    },
    updateTotBoxQty(boxQty) {
      this.tableData.forEach((row) => {
        row.qty = row.inPackageQty * boxQty
        row.boxQty = boxQty
      })
      this.tableDataChange()
    },
    tableDataChange() {
      setTimeout(() => {
        this.$emit('change', this.getTableData())
      }, 0)
    },
  },
}
</script>
<style scoped>
.spStyle {
  text-align: center;
  display: block;
  line-height: 28px;
}
</style>
